module.exports = __webpack_public_path__ + "img/agriculture_1.85bfef5a.jpg";